import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

interface BarChartItem {
  name: string;
  value: number;
  percentage?: number;
  highlight?: boolean;
}

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnChanges {

  @Input() data: BarChartItem[] = [];
  @Input() title = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.data || this.data.length === 0) {
      return;
    }

    const maxValue = Math.max(...this.data.map(item => item.value));

    // Se todos forem zero, não renderiza barras cheias
    if (maxValue === 0) {
      this.data = this.data.map(item => ({
        ...item,
        percentage: 0,
        highlight: false
      }));
      return;
    }

    this.data = this.data.map(item => ({
      ...item,
      percentage: Math.round((item.value / maxValue) * 100),
      highlight: item.value === maxValue && item.value > 0
    }));
  }
}
